import { useEffect } from 'react';
import { IContainerProps } from './IContainerProps';
import { useStore } from '@ui/hooks/useStore';
import useKeyDown from '@ui/hooks/useKeyDown';

const useCloseDeviceSettings = ({ onConfirm, onCancel, onClick, onClose }: IContainerProps) => {
    const { app, lang, devices } = useStore();
    const key = useKeyDown();

    const handleKey = (key: string) => {
        switch (key) {
            case 'Escape':
                onCancel();
                break;
        }
    };
    const handleConfirmClick = () => {
        onClick();      //СОХРАНЕНИЕ НАСТРОЕК  
        onConfirm(); //закрывает окно где ДА/НЕТ
        devices.setPreventoperationSuccess() 
        //ЭТО КОСТЫЛЬ. ОН ПОЗВОЛЯЕТ не открывать модальное окно 
        //с успешным обновлением настроек путем добавления 
        //к operationSuccess = true и проверки setPreventoperationSuccess
        onClose(); //ДОЛЖЕН УБИРАТЬ МОДАЛЬНОЕ ОКНО С УСПЕШНЫМ ОБНОВЛЕНИЕМ НАСТРОЕК       
        app.resetDeviceSettingsClosing();
        app.setDeviceSettingsClosed();       
    };
    const handleCancelClick = () => {
        onCancel();
        app.resetDeviceSettingsClosing();
    };
    const handlers = {
        
        handleConfirmClick,
        handleCancelClick,
    };

    useEffect(() => {
        handleKey(key);
    }, [key]);

    return {
        lang,
        handlers,
    };
};

export default useCloseDeviceSettings;
